import { BaseResource } from './base';
import type { Role } from '@gymspace/shared';
import type { PermissionsGroup } from '../models/roles';
import { RequestOptions } from '../types';

export class RolesResource extends BaseResource {
  private basePath = 'roles';

  /**
   * Get all roles of the organization (without pagination)
   */
  async getRoles(options?: RequestOptions): Promise<Role[]> {
    return this.client.get<Role[]>(this.basePath, undefined, options);
  }

  /**
   * Get a specific role by ID
   */
  async getRole(id: string, options?: RequestOptions): Promise<Role> {
    return this.client.get<Role>(`${this.basePath}/${id}`, undefined, options);
  }

  /**
   * Get all available permissions organized by category
   */
  async getAvailablePermissions(options?: RequestOptions): Promise<PermissionsGroup> {
    return this.client.get<PermissionsGroup>(`${this.basePath}/permissions`, undefined, options);
  }
}
